<template>
  <el-container class="layout-container">
    <el-aside width="200px">
      <div class="logo">
        <h3>启承智学管理系统</h3>
      </div>
      <el-menu :default-active="$route.path" router background-color="#304156" text-color="#bfcbd9"
        active-text-color="#409EFF">
        <el-menu-item index="/dashboard">
          <i class="el-icon-s-home"></i>
          <span slot="title">首页</span>
        </el-menu-item>
        <el-menu-item index="/admin/list">
          <i class="el-icon-user-solid"></i>
          <span slot="title">管理员管理</span>
        </el-menu-item>
        <el-menu-item v-if="isSuperAdmin" index="/school/list">
          <i class="el-icon-school"></i>
          <span slot="title">学校管理</span>
        </el-menu-item>
        <el-menu-item index="/teacher/list">
          <i class="el-icon-user"></i>
          <span slot="title">老师管理</span>
        </el-menu-item>
        <el-menu-item index="/class/list">
          <i class="el-icon-s-custom"></i>
          <span slot="title">班级管理</span>
        </el-menu-item>
        <el-menu-item index="/student/list">
          <i class="el-icon-user"></i>
          <span slot="title">学生管理</span>
        </el-menu-item>
        <el-menu-item index="/course/list">
          <i class="el-icon-notebook-1"></i>
          <span slot="title">课程管理</span>
        </el-menu-item>
        <el-menu-item index="/course/knowledge-point">
          <i class="el-icon-collection-tag"></i>
          <span slot="title">知识点管理</span>
        </el-menu-item>
        <el-menu-item index="/homework/list">
          <i class="el-icon-edit-outline"></i>
          <span slot="title">作业管理</span>
        </el-menu-item>
        <el-menu-item index="/material/list">
          <i class="el-icon-folder-opened"></i>
          <span slot="title">资料管理</span>
        </el-menu-item>
        <el-menu-item index="/task/list">
          <i class="el-icon-s-check"></i>
          <span slot="title">任务管理</span>
        </el-menu-item>
        <el-submenu index="/questionnaire" popper-class="submenu-dark">
          <template #title>
            <i class="el-icon-document"></i>
            <span slot="title">问卷管理</span>
          </template>
          <el-menu-item index="/questionnaire/list">
            <span slot="title">问卷列表</span>
          </el-menu-item>
          <el-menu-item index="/questionnaire/assign">
            <span slot="title">问卷分配</span>
          </el-menu-item>
        </el-submenu>
        <el-submenu index="/evaluation" popper-class="submenu-dark">
          <template #title>
            <i class="el-icon-data-analysis"></i>
            <span slot="title">测评分析</span>
          </template>
          <el-menu-item index="/evaluation/list">
            <span slot="title">测评列表</span>
          </el-menu-item>
          <el-menu-item index="/evaluation/result">
            <span slot="title">学生成绩</span>
          </el-menu-item>
        </el-submenu>
        <el-submenu index="/schedule" popper-class="submenu-dark">
          <template #title>
            <i class="el-icon-date"></i>
            <span slot="title">课程表管理</span>
          </template>
          <el-menu-item index="/schedule/list">
            <span slot="title">课程表列表</span>
          </el-menu-item>
          <el-menu-item index="/schedule/change">
            <span slot="title">变更历史</span>
          </el-menu-item>
        </el-submenu>
        <el-menu-item index="/attendance/list">
          <i class="el-icon-time"></i>
          <span slot="title">考勤管理</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header>
        <div class="header-right">
          <el-dropdown>
            <span class="el-dropdown-link">
              {{ displayName }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="openPasswordDialog">修改密码</el-dropdown-item>
              <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
    </el-container>

    <el-dialog
      title="修改密码"
      :visible.sync="passwordDialogVisible"
      width="420px"
      :close-on-click-modal="false"
      @closed="resetPasswordForm"
    >
      <el-form
        ref="passwordForm"
        :model="passwordForm"
        :rules="passwordRules"
        label-width="90px"
      >
        <el-form-item label="原密码" prop="oldPassword">
          <el-input
            v-model="passwordForm.oldPassword"
            type="password"
            show-password
            placeholder="请输入原密码"
            autocomplete="current-password"
          />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="passwordForm.newPassword"
            type="password"
            show-password
            placeholder="至少 6 位"
            autocomplete="new-password"
          />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            v-model="passwordForm.confirmPassword"
            type="password"
            show-password
            placeholder="再次输入新密码"
            autocomplete="new-password"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="passwordDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="passwordSubmitting" @click="submitPasswordChange">
          确定
        </el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
export default {
  name: "Layout",
  data() {
    const validateConfirm = (rule, value, callback) => {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error("两次输入的新密码不一致"));
      } else {
        callback();
      }
    };
    return {
      passwordDialogVisible: false,
      passwordSubmitting: false,
      passwordForm: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      passwordRules: {
        oldPassword: [{ required: true, message: "请输入原密码", trigger: "blur" }],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, message: "新密码长度不能少于6位", trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          { validator: validateConfirm, trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    isSuperAdmin() {
      const role = localStorage.getItem("role");
      return role === "super_admin";
    },
    displayName() {
      return localStorage.getItem("realName") || localStorage.getItem("username") || "管理员";
    },
  },
  methods: {
    openPasswordDialog() {
      this.passwordDialogVisible = true;
    },
    resetPasswordForm() {
      this.passwordForm = {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      };
      if (this.$refs.passwordForm) {
        this.$refs.passwordForm.clearValidate();
      }
    },
    submitPasswordChange() {
      this.$refs.passwordForm.validate(async (valid) => {
        if (!valid) return;
        this.passwordSubmitting = true;
        try {
          await this.$http.post("/api/admin/change-password", {
            oldPassword: this.passwordForm.oldPassword,
            newPassword: this.passwordForm.newPassword,
          });
          this.$message.success("密码修改成功，请重新登录");
          this.passwordDialogVisible = false;
          this.logout();
        } catch (e) {
          // 错误已由 http 拦截器提示
        } finally {
          this.passwordSubmitting = false;
        }
      });
    },
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("id");
      localStorage.removeItem("schoolId");
      localStorage.removeItem("username");
      localStorage.removeItem("role");
      localStorage.removeItem("realName");
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
.layout-container {
  height: 100vh;
}

.logo {
  background: #2b2f3a;
  color: white;
  text-align: center;
  padding: 20px 0;
  margin: 0;
}

.logo h3 {
  margin: 0;
  font-size: 16px;
}

.el-aside {
  background: #304156;
}

.el-header {
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.header-right {
  display: flex;
  align-items: center;
}

.el-dropdown-link {
  cursor: pointer;
  color: #606266;
}
</style>
